

import logoBranca from './img/logobranca.png'; 
import assinaturaLogo from './img/SiYourtraveldottv.png'; 
import galhodireito from './img/galhodireito.png'; 
import galhoesquerdo from './img/galhoesquerdo.png';
import bolaesquerda from './img/bolaesquerda.png';
import boladireita from './img/boladireita.png';

export default function Natal() {
  return (
    <div style={{ backgroundColor: "#0b2f25", minHeight: "100vh" }}>
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          backgroundColor: "#ffffff",
        }}
      >
        {/* TOPO */}
        <div
          style={{
            background:
              "radial-gradient(circle at center, #7db13c 0%, #0b2f25 70%)",
            padding: "50px 40px 90px",
            textAlign: "center",
            color: "#ffffff",
            position: "relative",
          }}
        >
          {/* Galhos decorativos (opcional) */}
         <img 
  src={galhodireito} 
  alt=""
  style={{ 
    position: 'absolute', 
    top: 0, 
    right: 0, // Use "right: 0" para canto direito
    width: "350px",
    margin: 0,
    padding: 0
  }} 
/>
<img 
  src={galhoesquerdo} 
  alt=""
  style={{ 
    position: 'absolute', 
    top: 0, 
    left: 0,
    width: "340px",
    margin: 0,
    padding: 0,
    zIndex: 1,
  }} 
/>
          

          <img
            src={logoBranca}
            alt="Biolink Soluções Ambientais"
            style={{ height: "55px", marginBottom: "30px" }}
          />

          <h1
            style={{
              fontSize: "30px",
              fontWeight: "normal",
              lineHeight: "1.4",
            }}
          >
            Prezados clientes, parceiros e
            <br />
            colaboradores,
          </h1>
        </div>

        {/* CONTEÚDO */}
        <div
          style={{
            padding: "60px 70px",
            textAlign: "center",
            color: "#1f1f1f",
            fontFamily: "Georgia, 'Times New Roman', serif",
          }}
        >
          <p style={{  marginBottom: "18px",fontSize: "18px" }}>
            À medida que nos aproximamos do encerramento de mais um ciclo,
            queremos expressar nossa mais sincera gratidão pela confiança,
            parceria e dedicação ao longo deste ano.
          </p>

          <p style={{ marginBottom: "18px",fontSize: "18px" }}>
            Foi um período de grandes desafios, aprendizados e conquistas, e
            nada disso seria possível sem a colaboração de cada um.
          </p>

          <p
            style={{
              color: "#8bcf2f",
              fontWeight: "bold",
              marginBottom: "18px",
              fontSize: "30px",
            }}
          >
            DE VOCÊS!
          </p>

          <p style={{ marginBottom: "18px" ,fontSize: "18px"}}>
            Somos muito gratos por ter ao nosso lado nessa caminhada. Clientes
            que acreditam em nosso trabalho, parceiros que compartilham
            objetivos e colaboradores que dedicam seu talento e esforço;
            vocês fazem a diferença para cada resultado alcançado.
          </p>

          <p style={{ marginBottom: "10px" ,fontSize: "18px" }}>
            Desejamos que este momento seja repleto de:
          </p>

          <p
            style={{
              color: "#8bcf2f",
              fontWeight: "bold",
              fontSize: "35px",
              margin: "25px 0",
            }}
          >
            ALEGRIA, PAZ e RENOVAÇÃO DE ENERGIAS.
          </p>

          <p style={{ marginBottom: "18px",fontSize: "20px" }}>
            Que o novo ano traga ainda mais oportunidades, prosperidade e
            momentos de sucesso compartilhado.
          </p>

          <p style={{ marginBottom: "30px",fontSize: "20px"}}>
            Continuamos firmes em nossa missão, com o compromisso de oferecer
            soluções de qualidade, excelência técnica e parcerias duradouras.
          </p>

          {/* ASSINATURA */}
          <div style={{ fontSize: "20px", marginTop: "35px",fontWeight: "bold" }}>
            <p>
              Com os melhores votos de felicidade e realizações,
              <br />
              Biolink Soluções Ambientais
            </p>

            <img
              src={assinaturaLogo}
              alt="Biolink"
              style={{ height: "55px", marginTop: "15px" }}
            />
          </div>
        </div>

        {/* RODAPÉ */}
        <div
          style={{
            background:
              "linear-gradient(to top, #0b2f25 0%, #7db13c 100%)",
            padding: "60px",
            position: "relative",
          }}
        >
          {/* Bolas decorativas (opcional) */}
          { <img src={bolaesquerda} alt="" style={{ position:'absolute', bottom:0, left:0, width: "300px" }} /> }
          { <img src={boladireita } alt="" style={{ position:'absolute', bottom:0, right:0, width: "300px" }} /> }
          {/* <img src="/assets/bola-direita.png" style={{ position:'absolute', bottom:0, right:0 }} /> */}
        </div>
      </div>
    </div>
  );
}
